import { Percent } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { useI18n } from '@/hooks/useI18n';
import { useMyPlatformFeeRate } from '@/hooks/usePlatformFee';
import { formatPlatformFeeRate } from '@/lib/payments/utils/payment-method';

/**
 * Aliquota della fee Place2Be concordata con l'agenzia o con l'indipendente. Compare SOLO
 * se diversa dal default: chi paga il 3% standard non ha niente da leggere qui, e una card
 * "3%" in ogni profilo farebbe pensare a un valore negoziabile da soli.
 */
const PlatformFeeRateCard = ({ className }: { className?: string }) => {
  const { t } = useI18n();
  const { data } = useMyPlatformFeeRate();

  if (!data || data.is_default) return null;

  return (
    <Card className={className}>
      <CardHeader>
        <CardTitle className="text-xl font-normal flex items-center gap-2">
          <Percent className="h-4 w-4" />
          {t('settings.platformFee.title')}
        </CardTitle>
      </CardHeader>
      <CardContent className="flex flex-col gap-1">
        <p className="text-2xl font-semibold text-gray-900 tabular-nums">
          {formatPlatformFeeRate(data.rate)}
        </p>
        <p className="text-sm text-gray-500">
          {t('settings.platformFee.description', { default: formatPlatformFeeRate(data.default_rate) })}
        </p>
      </CardContent>
    </Card>
  );
};

export default PlatformFeeRateCard;
